module.exports = __webpack_public_path__ + "media/Icons/StartedIcon-22703c31.png";